import { Button, Typography } from '@breetometer/components';
import { AngleRightNavIcon, CopyIcon, ResolutionFeeIcon, TopUpMinimumIcon } from 'BreetAssets';
import { copyToClipboard, viewIntercomArticle } from 'BreetHelpers';

import type { IResolveTradeMenuSelection } from '../DialogResolveTrade.helpers';

const MenuSelection = ({
	onPayResolutionFees,
	onTopUpMinimum,
	assetSymbol,
	minimumValue,
	resolutionFee,
}: IResolveTradeMenuSelection) => (
	<div className='resolvetrade_menuselection'>
		<div className='resolvetrade_header'>
			<Typography
				as='h1'
				className='color-neutral-50'
			>
				How to resolve trade?
			</Typography>
		</div>

		<div className='resolvetrade_menuselectionitem border-dark-navy'>
			<TopUpMinimumIcon className='resolvetrade_menuselectionitem_icon svg-dark svg-dark-outline' />

			<div>
				<Typography
					as='h6'
					className='color-neutral-50'
				>
					Top-up Minimum
				</Typography>

				<div className='resolvetrade_menuselectionitem_amount'>
					<Typography className='color-tertiary-400'>
						{minimumValue} {assetSymbol}
					</Typography>
					<CopyIcon
						variant='negative'
						className='cursor_pointer svg-dark'
						focusable
						onClick={copyToClipboard(String(minimumValue), 'Minimum value copied')}
					/>
				</div>

				<div className='resolvetrade_menuselectionitem_description'>
					<Button
						variant='native'
						onClick={onTopUpMinimum}
					>
						<Typography
							as='span'
							className='color-primary-100'
						>
							Send the minimum value to resolve your flagged trade(s). It resolves automatically.
						</Typography>
					</Button>
					<Typography
						as='a'
						onClick={viewIntercomArticle('11856241')}
					>
						Learn more.
					</Typography>
				</div>
			</div>

			<Button
				variant='native'
				onClick={onTopUpMinimum}
			>
				<AngleRightNavIcon
					variant='small'
					className='resolvetrade_menuselectionitem_navicon svg-dark'
				/>
			</Button>
		</div>

		<div className='resolvetrade_menuselectionitem border-dark-navy'>
			<ResolutionFeeIcon className='resolvetrade_menuselectionitem_icon svg-dark svg-dark-outline' />

			<div>
				<Typography
					as='h6'
					className='color-neutral-50'
				>
					Pay Resolution Fee
				</Typography>

				<div className='resolvetrade_menuselectionitem_description'>
					<Button
						variant='native'
						onClick={onPayResolutionFees}
					>
						<Typography
							as='span'
							className='color-primary-100'
						>
							A <span className='bold color-tertiary-400'>${resolutionFee}</span> resolution fee will be deducted from the USD
							value of the received crypto, and the remaining amount will be credited to your wallet immediately.
						</Typography>
					</Button>
					<Typography
						as='a'
						onClick={viewIntercomArticle('11856536')}
					>
						Learn more.
					</Typography>
				</div>
			</div>

			<Button
				variant='native'
				onClick={onPayResolutionFees}
			>
				<AngleRightNavIcon
					variant='small'
					className='resolvetrade_menuselectionitem_navicon svg-dark'
				/>
			</Button>
		</div>
	</div>
);

export default MenuSelection;
